import { render, staticRenderFns } from "./EdenContentEmpty.vue?vue&type=template&id=58cbdb3a"
import script from "./EdenContentEmpty.vue?vue&type=script&lang=js"
export * from "./EdenContentEmpty.vue?vue&type=script&lang=js"
import style0 from "./EdenContentEmpty.vue?vue&type=style&index=0&id=58cbdb3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports